import { __decorate, __metadata } from 'tslib';
import { ɵɵdefineInjectable, Injectable, EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiCInputModule } from '@wlp/ui-c-input';

let UiCResponsibleMeiDataService = class UiCResponsibleMeiDataService {
    constructor() { }
};
UiCResponsibleMeiDataService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UiCResponsibleMeiDataService_Factory() { return new UiCResponsibleMeiDataService(); }, token: UiCResponsibleMeiDataService, providedIn: "root" });
UiCResponsibleMeiDataService = __decorate([
    Injectable({
        providedIn: 'root'
    }),
    __metadata("design:paramtypes", [])
], UiCResponsibleMeiDataService);

let UiCResponsibleMeiDataComponent = class UiCResponsibleMeiDataComponent {
    constructor() {
        this.isOnboardingV2 = false;
        this.finish = new EventEmitter();
    }
    ngOnInit() { }
    goContinue() {
        this.finish.emit(this.businessDataForm);
    }
};
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCResponsibleMeiDataComponent.prototype, "errorMessages", void 0);
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], UiCResponsibleMeiDataComponent.prototype, "businessDataForm", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCResponsibleMeiDataComponent.prototype, "isOnboardingV2", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], UiCResponsibleMeiDataComponent.prototype, "finish", void 0);
UiCResponsibleMeiDataComponent = __decorate([
    Component({
        selector: 'ui-c-responsible-mei-data',
        template: "<div class=\"responsible-mei-form\">\n  <ion-row class=\"row-container col-10 ion-justify-content-left ion-align-items-center px-0\">\n    <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\">\n      <ui-c-input data-cy=\"onboarding-mei-name\" [errorMessages]=\"errorMessages\" [form]=\"businessDataForm\"\n        [formName]=\"'fullname'\" [placeholder]=\"'ONBORDING.V2.FORM.PLACEHOLDER.FULL_NAME' | wlpTranslate\"\n        [name]=\"'ONBORDING.V2.FORM.LABEL.FULL_NAME' | wlpTranslate\">\n      </ui-c-input>\n    </ion-col>\n\n    <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\">\n      <ui-c-input data-cy=\"onboarding-mei-document\" [errorMessages]=\"errorMessages\" [form]=\"businessDataForm\"\n        [isCPF]=\"true\" [formName]=\"'docNumber'\" [placeholder]=\"'ONBORDING.V2.FORM.PLACEHOLDER.CPF' | wlpTranslate\"\n        [name]=\"'ONBORDING.V2.FORM.LABEL.CPF' | wlpTranslate\">\n      </ui-c-input>\n    </ion-col>\n\n    <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\" *ngIf=\"!isOnboardingV2\">\n      <ui-c-input data-cy=\"onboarding-mei-email\" [errorMessages]=\"errorMessages\" [form]=\"businessDataForm\"\n        [formName]=\"'email'\" [placeholder]=\"'ONBORDING.V2.FORM.PLACEHOLDER.EMAIL' | wlpTranslate\"\n        [name]=\"'ONBORDING.V2.FORM.LABEL.EMAIL' | wlpTranslate\">\n        >\n      </ui-c-input>\n    </ion-col>\n\n    <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\">\n      <ui-c-input data-cy=\"onboarding-mei-phone\" [errorMessages]=\"errorMessages\" [form]=\"businessDataForm\"\n        [formName]=\"'phone'\" [placeholder]=\"'ONBORDING.V2.FORM.PLACEHOLDER.PHONE' | wlpTranslate\"\n        [name]=\"'ONBORDING.V2.FORM.LABEL.PHONE' | wlpTranslate\" [maxlength]=\"15\" [isPhone]=\"true\">\n      </ui-c-input>\n    </ion-col>\n  </ion-row>\n\n  <ion-row class=\"ion-justify-content-left ion-margin-top ion-margin-bottom\">\n    <ion-col [size]=\"12\" [sizeMd]=\"4\" [sizeSm]=\"4\">\n      <ui-c-button data-cy=\"onboarding-responsiblemei-btn\" [disabled]=\"businessDataForm.invalid\" \n        expand=\"block\" (continue)=\"goContinue()\">\n        {{ 'ONBORDING.V2.BUTTON.NEXT' | wlpTranslate }}\n      </ui-c-button>\n    </ion-col>\n  </ion-row>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCResponsibleMeiDataComponent);

let UiCResponsibleMeiDataModule = class UiCResponsibleMeiDataModule {
};
UiCResponsibleMeiDataModule = __decorate([
    NgModule({
        declarations: [
            UiCResponsibleMeiDataComponent
        ],
        exports: [
            UiCResponsibleMeiDataComponent
        ],
        imports: [
            IonicModule,
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            UiCInputModule,
            UiCButtonModule,
            UiBsTranslateModule
        ]
    })
], UiCResponsibleMeiDataModule);

export { UiCResponsibleMeiDataComponent, UiCResponsibleMeiDataModule, UiCResponsibleMeiDataService };
//# sourceMappingURL=wlp-ui-c-responsible-mei-data.js.map
